
export default {
    name: "error",
    props: ["error"],
    data(){
        return {
            viewportW: 0,
            viewportH: 0,
            isShowMessage: false,
            messageDelay: 2000,
            messageTimer: null,
        }
    },
    computed: {
        isMobileViewport(){
            if(!this.viewportW) return false;
            return this.viewportW < 768 || this.viewportH < 500;
        },
        mapImage(){
            const item = this.isMobileViewport? (this.lobbyMap.imageMobile || this.lobbyMap.image) : this.lobbyMap.image;
            return this.formattedAssetUrl(item);
        },
        viewBox(){
            const { focus, imageW, imageH } = this.lobbyMap;
            const item = this.isMobileViewport? focus.mobile : focus.desktop;
            return `${ item.x / 100 * imageW } ${ item.y / 100 * imageH } ${ item.width / 100 * imageW } ${ item.height / 100 * imageH }`;
        },
        skyStyle(){
            const { skyFrom, skyVia, skyTo } = this.lobbyMap;
            return { background: `linear-gradient(to bottom, ${ skyFrom } 0%, ${ skyVia } 55%, ${ skyTo } 100%)` };
        },
        skyImageStyle(){
            return { background: `url(${ this.mapImage }) center bottom / cover no-repeat` };
        },
        message(){
            if(this.error && this.error.statusCode == 404) return "We couldn't find that part of the festival.";
            return "Something went wrong along the way.";
        },
    },
    mounted(){
        this.onHandleViewportResize();
        window.addEventListener("resize", this.onHandleViewportResize);
        this.messageTimer = setTimeout(() => { this.isShowMessage = true; }, this.messageDelay);
    },
    beforeDestroy(){
        window.removeEventListener("resize", this.onHandleViewportResize);
        clearTimeout(this.messageTimer);
    },
    methods: {
        onHandleViewportResize(){
            this.viewportW = window.innerWidth;
            this.viewportH = window.innerHeight;
        },
        onClickBackBtn(){
            window.location.href = this.user? "/lobby/" : "/";
        },
    },
}
